export default __webpack_public_path__ + "alberta-crm.c53b5f6bd2d378374d13.svg";